// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__DEqP5","list":"PatternAutocomplete_list__3kOyM"};